require([
  "share",
  "lightbox",
  "scrollPlay",
  "tweets",
  "comments/package",
  "lib/component-responsive-frame/build/responsive-frame"
], function(Share) {
  
  var share = new Share(".share", {
    ui: {
      flyout: "bottom left"
    }
  });

  //capability checks
  if ("transform" in document.body.style) {
    document.documentElement.className += "transformable";
  }

  //iOS 7 is the worst
  if (navigator.userAgent.match(/(iphone|ipad).*OS 7_/i)) {
    [].slice.call(document.querySelectorAll("video")).forEach(function(v) {
      v.setAttribute("controls", "true");
    });
  }

  var precache = new Image();
  precache.onload = function() {
    var animation = document.querySelector(".animation");
    if (animation) animation.className += " go";
  };
  precache.src = "../assets/barcode/bars.jpg";
  
});

define("main", function(){});

